// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {findMatchingKey} from '../../shared/services/claim-shared-helper';

export const addPart = () => ({
    type: actions.CREATE_CLAIM_SPA_PART
});

export const deletePart = index => ({
    index,
    type: actions.DELETE_CLAIM_SPA_PART
});

export const changePartsUnit = (index, unit, unitCollection) => ({
    data: findMatchingKey(unit, unitCollection),
    index,
    type: actions.UPDATE_CLAIM_SPA_PART_UNIT
});

export const changePartProperty = (index, data, property) => ({
    data,
    index,
    property,
    type: actions.UPDATE_CLAIM_SPA_PART_FIELDS
});



// WEBPACK FOOTER //
// ./src/claim/spa/action-creators/parts.js